export const PAGE_SIZE = 10;

export type SortOrder = "asc" | "desc";

export function formatHours(hours: number): string {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h} hrs`;
  return `${h} hrs ${m} min`;
}

/** Sorts rows by column; accepts any object type (e.g. DTOs or Record<string, unknown>). */
export function sortReportData<T extends object>(
  data: T[],
  column: string | null,
  order: SortOrder
): T[] {
  if (!column || !data.length) return data;
  return [...data].sort((a, b) => {
    const aVal = (a as Record<string, unknown>)[column];
    const bVal = (b as Record<string, unknown>)[column];
    if (column === "Date of Last Completion") {
      const toTime = (v: unknown) => {
        if (v == null || v === "") return 0;
        const t = new Date(String(v)).getTime();
        return Number.isNaN(t) ? 0 : t;
      };
      const aT = toTime(aVal);
      const bT = toTime(bVal);
      return order === "asc" ? aT - bT : bT - aT;
    }
    const aNum = typeof aVal === "number" ? aVal : parseFloat(String(aVal).replace(/[^0-9.-]/g, ""));
    const bNum = typeof bVal === "number" ? bVal : parseFloat(String(bVal).replace(/[^0-9.-]/g, ""));
    if (!isNaN(aNum) && !isNaN(bNum)) return order === "asc" ? aNum - bNum : bNum - aNum;
    const aStr = String(aVal ?? "").toLowerCase();
    const bStr = String(bVal ?? "").toLowerCase();
    if (aStr < bStr) return order === "asc" ? -1 : 1;
    if (aStr > bStr) return order === "asc" ? 1 : -1;
    return 0;
  });
}
